import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=b63537f4&"
import script from "./WarningDialog.vue?vue&type=script&lang=js&"
export * from "./WarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./WarningDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports